// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7e8f65f8","455":"733e8281","977":"9705eee8"}[chunkId] + ".chunk.js";
};